<template>
  <div>
    <Suspense>
      <template #default>
        <banned-users-list />
      </template>
      <template #fallback>
        <a-loader :title="$translate('profile.other.loadingBannedUsers')" />
      </template>
    </Suspense>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ALoader from '@/components/ALoader.vue'
import BannedUsersList from '@/components/Profile/BannedUsersList.vue'

export default defineComponent({
  name: 'BlockedUserList',
  components: { BannedUsersList, ALoader },
})
</script>
